import React, { useState } from "react";
import GoogleMapReact from "google-map-react";

import { isEmpty } from "lodash";
import { Spin, Switch } from "antd";
import { TRIP_TYPE_ID } from "../../../../configs/constants";
import { displayDurationTrip } from "../../utils/date.utils";
import { get } from "../../utils/utils";
import { computeCenterAndZoomOfListOfGps, UPSELL_GPS } from "../../utils/map.utils";
import Marker from "../../components/Marker";

const TOKEN = "AIzaSyDxkSpxLuz_dGanirSXNDuvA_6pDDPJafo";

function getRandomColor(seed) {
  if (seed === 0) return "#000000";
  const x = Math.sin(seed++) * 10000;
  const randomNb = x - Math.floor(x);
  return `#${Math.floor(randomNb * 16777215).toString(16)}`;
}

const Trip = ({ trip, onChange, isLoading, i }) => {
  const path = trip.path || {};
  const startLocation = get([0, "label"], path, "N/C");
  const endLocation = get([path.length - 1, "label"], path, "N/C");

  return (
    <div className="my-6" key={trip.id}>
      <div className="my-2">
        <span className="my-1 mx-2 font-bold">{`Trajet ${i + 1} :`} </span>
        <span className={`rounded-full ${trip.type.id === 1 ? "bg-green-400" : "bg-red-500"} text-white px-2`}>
          {`${trip.type.label}`}{" "}
        </span>
      </div>

      <div className="my-2">
        <span className="ml-2 font-bold mr-2">Perso</span>
        {isLoading ? (
          <Spin></Spin>
        ) : (
          <Switch checked={trip.type.id === TRIP_TYPE_ID.PRO} onChange={checked => onChange(checked)} />
        )}
        <span className="font-bold ml-2">Pro</span>
      </div>

      <div className="my-2">
        <span className="my-1 mx-2 font-bold">{`Distance : `}</span>
        <span className="text-red-500"> {`${parseInt(trip.distance)}km`} </span>
      </div>
      <div className="my-2">
        <span className="my-1 mx-2 font-bold">{`Durée :`}</span>
        <span>{displayDurationTrip(trip.start_date, trip.end_date)}</span>
      </div>
      <div className="my-2">
        <span className="my-1 mx-2 font-bold">{`Départ :`}</span>
        <span className="my-1 mx-2 font-bold">{startLocation}</span>
      </div>
      <div className="my-2">
        <span className="my-1 mx-2 font-bold">{`Arrivée :`}</span>
        <span className="my-1 mx-2 font-bold">{endLocation}</span>
      </div>
    </div>
  );
};
const QualifyDayTrip = ({ dayIndex, indexSelected, updateTrip, day, closeModal }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [trips, setTrips] = useState(day.trips || []);

  const visits = day.visits || [];
  const [tripsToUpdate, setTripsToUpdate] = useState([]);

  const markers = trips
    .map((trip, i) =>
      Array.isArray(trip.path)
        ? trip.path.map((point, p) => ({
            ...point,
            lat: point.lat || UPSELL_GPS.lat,
            lng: point.long || UPSELL_GPS.lng,
            label: p === 0 ? i + 1 : null,
            color: `${getRandomColor(i + 1)}`
          }))
        : []
    )
    .flat();

  const markersUserPositions = visits
    .map((visit, i) => ({
      lat: visit.gps_lat,
      lng: visit.gps_long,
      label: "cs",
      color: `${getRandomColor(i + 1)}`
    }))
    .filter(visit => visit);
  const markersPdcsPositions = visits
    .map((visit, i) => ({
      lat: visit.salepoint ? visit.salepoint.gps_lat : null,
      lng: visit.salepoint ? visit.salepoint.gps_long : null,
      label: visit.pdc_label,
      color: `${getRandomColor(i + 1)}`
    }))
    .filter(visit => visit);
  const defaultZoom = 6;
  const defaultLat = get([0, "lat"], markers, UPSELL_GPS.lat);
  const defaultLng = get([0, "lng"], markers, UPSELL_GPS.lng);
  const centerDefault = { lat: defaultLat, lng: defaultLng };
  let center = centerDefault;
  let zoom = defaultZoom;

  const centerAndZoom = computeCenterAndZoomOfListOfGps(markers, 600, 600);
  center = centerAndZoom.center;
  zoom = centerAndZoom.zoom;

  const handleClickOk = async () => {
    if (!isEmpty(tripsToUpdate)) {
      setIsLoading(true);
      tripsToUpdate.map(eachTrip => {
        updateTrip({ ...eachTrip, weekIndex: indexSelected, dayIndex: dayIndex });
      });
      setIsLoading(false);
      closeModal();
    }
  };

  return (
    <div className="my-5" key={day.date}>
      <div className="mt-6 flex justify-center">
        <div
          className={`cursor-pointer px-6 py-2 mx-2 leading-5 rounded-full text-white ${
            tripsToUpdate.length === 0 ? "bg-grey-400" : "bg-green-500"
          }`}
          onClick={() => handleClickOk()}
        >
          Enregistrer les changements
        </div>
        <div
          className={`cursor-pointer px-6 py-2 mx-2 leading-5 rounded-full p-btn-grey text-white`}
          onClick={() => {
            setTrips(day.trips || []);
            setTripsToUpdate([]);
            closeModal();
          }}
        >
          {tripsToUpdate.length === 0 ? "Refermer sans changement" : "Annuler les changements"}
        </div>
      </div>
      <div className="font-bold text-lg">{day.date}</div>
      <div className="my-2 justify-around items-center flex">
        <div style={{ width: 600, height: 600 }}>
          <GoogleMapReact
            bootstrapURLKeys={{ key: TOKEN }}
            defaultCenter={centerDefault}
            defaultZoom={defaultZoom}
            center={center}
            zoom={zoom}
            yesIWantToUseGoogleMapApiInternals
            onGoogleApiLoaded={({ map, maps }) => {
              const lineSymbol = {
                path: maps.SymbolPath.FORWARD_CLOSED_ARROW
              };

              for (let i = 0; i < markers.length - 1; i++) {
                let tripPath = new maps.Polyline({
                  path: [markers[i], markers[i + 1]],
                  geodesic: true,
                  strokeColor: markers[i].color,
                  strokeOpacity: 1.0,
                  strokeWeight: 2,
                  icons: [{ icon: lineSymbol, offset: "100%" }]
                });

                tripPath.setMap(map);
              }

              for (let i = 0; i < markersPdcsPositions.length; i++) {
                let distanceUserSalepoint = new maps.Polyline({
                  path: [markersUserPositions[i], markersPdcsPositions[i]],
                  geodesic: true,
                  strokeColor: `#FF0000`,
                  strokeOpacity: 1,
                  strokeWeight: 5,
                  icons: [{ offset: "100%" }]
                });

                distanceUserSalepoint.setMap(map);
              }
            }}
          >
            {markers.map((marker, i) => (
              <Marker key={i} lng={marker.lng} lat={marker.lat} text={marker.label} color={marker.color} />
            ))}
            {markersPdcsPositions.map((marker, i) => (
              <Marker key={i} lng={marker.lng} lat={marker.lat} type={"shop"} color={marker.color} />
            ))}
            {markersUserPositions.map((marker, i) => (
              <Marker key={i} lng={marker.lng} lat={marker.lat} type={"play-circle"} color={marker.color} />
            ))}
          </GoogleMapReact>
        </div>
        <div className="w-1/5">
          {trips.length > 0 ? (
            trips.map((trip, i) => (
              <Trip
                trip={trip}
                i={i}
                onChange={checked => {
                  const tripsUpdated = [...trips];

                  tripsUpdated[i] = {
                    ...trip,
                    type: {
                      label: checked ? "pro" : "perso",
                      id: checked ? TRIP_TYPE_ID.PRO : TRIP_TYPE_ID.PERSO
                    },
                    tripIndex: i
                  };
                  setTrips(tripsUpdated);
                  if (day && day.trips[i].type.id !== tripsUpdated[i].type.id) {
                    setTripsToUpdate([...tripsToUpdate, tripsUpdated[i]]);
                  } else if (tripsToUpdate.find(item => item.id === trip.id)) {
                    const getIndex = tripsToUpdate.findIndex(item => item.id === tripsUpdated[i].id);

                    setTripsToUpdate(tripsToUpdate.splice(getIndex, 1));
                  }
                }}
                isLoading={isLoading}
              />
            ))
          ) : (
            <div>Aucun trajet ce jour</div>
          )}
        </div>
      </div>
      <div className="mt-6 flex justify-center">
        <div
          className={`cursor-pointer px-6 py-2 mx-2 leading-5 rounded-full text-white ${
            tripsToUpdate.length === 0 ? "bg-grey-400" : "bg-green-500"
          }`}
          onClick={() => handleClickOk()}
        >
          Enregistrer les changements
        </div>
        <div
          className={`cursor-pointer px-6 py-2 mx-2 leading-5 rounded-full p-btn-grey text-white`}
          onClick={() => {
            setTrips(day.trips || []);
            setTripsToUpdate([]);
            closeModal();
          }}
        >
          {tripsToUpdate.length === 0 ? "Refermer sans changement" : "Annuler les changements"}
        </div>
      </div>
    </div>
  );
};

export default QualifyDayTrip;



// WEBPACK FOOTER //
// src/modules/presence/presence/modals/QualifyDayTrips.js